import { createStore } from 'vuex';
import router from '../router'

import videos from './modules/videos';
import login from './modules/login';
import filelist from './modules/filelist';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

let testingRemote = (process.env.NODE_ENV === 'production') ? false : false;
	
const appPath = (global.isOffline) ? global.electronStore.get("appPath") : null
const apiPath = (testingRemote) ? process.env.VUE_APP_API_REMOTE_PATH : process.env.VUE_APP_API_PATH
const publicPath = (testingRemote) ? process.env.VUE_APP_REMOTE_PUBLIC_PATH : process.env.VUE_APP_PUBLIC_PATH
console.log("appPath", appPath)
console.log('apiPath', apiPath)
console.log('publicPath', publicPath)
const scrollbehavior = (global.isOffline) ? global.electronStore.get("scrollbehavior") : 'smooth'

export default createStore({
  state: {
    packageVersion: process.env.PACKAGE_VERSION || '0',
    appPath: appPath,
    apiPath: apiPath,
    publicPath: publicPath,
		isOffline: global.isOffline,
    section: null,
    scrollbehavior: scrollbehavior,
    brokerEnabled: false,
  },
  mutations: {
    SET_SECTION(state, payload) {
			state.section = payload
      console.log("UPDATE section =>", state.section);
    },
    SET_MENUCOLOR(state, payload) {
			state.menucolor = payload
    },
    SET_BROKER_ENABLED(state, payload) {
			state.brokerEnabled = payload
      console.log("SET_BROKER_ENABLED =>", payload);
    },
  },
  actions: {
    writeLog({ getters }, data) {
      if (getters.isOffline) {
        window.top.ipcRenderer.send('writeLog', {
          data: data,
          level: 'info'
        });
      } else {
        console.log(data)
      }
    },
    startFullScreen({ getters }) {
      var docElm = document.documentElement;
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
      console.log('fullscreen');
      if (global.isOffline) {
          window.top.ipcRenderer.send("MainWindowLaunched", {
            section: getters.section
          })
        }
    },
    exitFullScreen() {
      if (!document.fullscreenElement) return
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      console.log('exit fullscreen');
      if (global.isOffline) window.top.ipcRenderer.send("MainWindowClosed")
    },
    goToPage(context, id) {
      if (!id || isNaN(id)) return false
      console.log('goToPage', id)
      router.push('/page/' + id)
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      })
    },
    goHome({ dispatch }) {
      router.push('/home')
      dispatch('startFullScreen')
    },
    async setSection({ dispatch, commit }, payload) {
      commit('SET_SECTION', payload)
      if (payload) {
        if (global.isOffline) {
          window.top.ipcRenderer.send('setSection', {
            section: payload
          });
        }
        dispatch('goHome')
      } else {
        router.push('/')
        dispatch('exitFullScreen')
      }
    },
    async launchSection({ dispatch, commit }, payload) {
      commit('SET_SECTION', payload)
      return dispatch('filelist/getOfflineItems').then((response) => {
        //console.log('getOfflineItems response', response)
        return response
      })
    },
    launchPdf({ getters }, ev) {
      ev.preventDefault()
      let el = ev.target
      let path = el.getAttribute('href')
      //console.log('launchPdf', path)
      if (getters.isIos) {
        window.open(path)
      } else {
        new Fancybox([
          {
              src: path,
              type: 'pdf',
          }
        ]);
      }
    },
    checkBrokerEnabled({ commit }) {
      if (global.isOffline) return false
      let brokerEnabled = false
      fetch('config.json')
      .then(response => response.json())
      .then((json) => {
        //console.log('config', json)
        Object.keys(json).forEach(function(index) {
          let item = json[index]
          if (item.name == 'broker_enabled') {
            brokerEnabled = Boolean(item.value)
          }
        })
        commit('SET_BROKER_ENABLED', brokerEnabled)
      })
    }
  },
  getters: {
    appVersion: (state) => state.packageVersion,
		appPath: (state) => state.appPath,
		apiPath: (state) => state.apiPath,
		publicPath: (state) => state.publicPath,
    isOffline: (state) => state.isOffline,
    section: (state) => state.section,
    scrollbehavior: (state) => state.scrollbehavior,
    brokerEnabled: (state) => state.brokerEnabled,
    isIos: () => {
      var userAgent = window.navigator.userAgent.toLowerCase()
      console.log('userAgent', userAgent)
      if (
        userAgent.indexOf("iphone") != -1 ||
        userAgent.indexOf("ipad") != -1 ||
        userAgent.indexOf("android") != -1 ||
        userAgent.indexOf("mobile") != -1
      ) {
        return true
      } else {
        return false
      }
    },
  },
  modules: {
    videos,
    login,
    filelist
  },
})

